export enum LENS_TYPES {
    singleVision = 'Single Vision',
    singleVisionReaders = 'Single Vision Readers',
    bifocal      = 'Bifocal',
    progressive = 'Progressive',
    bifocalProg = 'Bifocal/Progressive',
    plano = 'Single Vision Plano'
}

export enum LENS {
  bifocal = 6,
  basicProg = 8
}

